/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { string, object, func, oneOf, bool, oneOfType, shape, node, element, } from 'prop-types';
import setClass from '../../common/set-class';
import Icon from '../icon';
function ChipIcon({ name, onClick, disabled, asImage, setHoverBlock }) {
    function clickHandler(e) {
        if (onClick && !disabled) {
            e.stopPropagation();
            onClick(e);
        }
    }
    const responsiveClass = onClick && !disabled && 'b-chip--responsive';
    const handlers = {
        onMouseOver: () => setHoverBlock(true),
        onMouseLeave: () => setHoverBlock(false),
        onClick: clickHandler,
    };
    return asImage ? (React.createElement("img", { src: name, alt: "chip-icon", className: setClass(['b-chip__img', responsiveClass]), ...handlers })) : (React.createElement(Icon, { name: name, className: setClass(['b-chip__icon', responsiveClass]), ...handlers }));
}
function Chip({ chipRef, kind, size, style, className, iconLeft, iconRight, asImage, onLeftIconClick, onRightIconClick, onChipBodyClick, text, disabled, }) {
    const isBodyClickable = onChipBodyClick && !disabled;
    const _asImage = typeof asImage === 'boolean' ? { left: asImage, right: asImage } : asImage;
    const [blockedByIcon, setBlockedByIcon] = useState(false);
    return (React.createElement("div", { ref: chipRef, className: setClass([
            'b-flex-gmicro',
            'b-chip__root',
            `b-chip--kind-${kind}`,
            `b-chip--size-${size}`,
            isBodyClickable && 'b-chip--responsive',
            !blockedByIcon &&
                isBodyClickable &&
                kind === 'tertiary' &&
                'b-chip--tertiary-clickable',
            disabled && 'b-chip--disabled',
            className,
        ]), style: style, onClick: onChipBodyClick },
        iconLeft && (React.createElement(ChipIcon, { name: iconLeft, onClick: onLeftIconClick, disabled: disabled, asImage: !!_asImage?.left, setHoverBlock: setBlockedByIcon })),
        React.createElement("span", { className: "b-chip__text" }, text),
        iconRight && (React.createElement(ChipIcon, { name: iconRight, onClick: onRightIconClick, disabled: disabled, asImage: !!_asImage?.right, setHoverBlock: setBlockedByIcon }))));
}
Chip.propTypes = {
    kind: oneOf([
        'primary',
        'inactive',
        'secondary',
        'tertiary',
        'tertiary-light',
        'tertiary-lighter',
        'primary-bright',
        'preview',
        'alert',
        'active',
        'info',
        'dull',
    ]),
    size: oneOf(['sm', 'md', 'lg']),
    style: object,
    className: string,
    iconLeft: string,
    iconRight: string,
    asImage: oneOfType([bool, shape({ left: bool, right: bool })]),
    onLeftIconClick: func,
    onRightIconClick: func,
    onChipBodyClick: func,
    text: string,
    disabled: bool,
    chipRef: oneOfType([node, element, func]),
};
Chip.defaultProps = {
    kind: 'primary',
    size: 'md',
    style: null,
    className: null,
    iconLeft: null,
    iconRight: null,
    asImage: false,
    onRightIconClick: null,
    onLeftIconClick: null,
    onChipBodyClick: null,
    text: '',
    disabled: false,
    chipRef: null,
};
export default Chip;
